export default __webpack_public_path__ + "static/features-automated-transcripts-lg-bbfa75d52e9ab2142cca9d8885548b75.jpg";